module.exports = __webpack_public_path__ + "media/images/icons-369b4a2b538922ce280d9bfea2c1720d.svg";